import { glowMinderABTestRouteConfig } from '@/config/abTestConfig'
import { navigateToNextOnboardingPage } from '@app-studio-web/ui/helpers/abTestRouting'
import { getABTestVariantFromContext } from '@app-studio-web/ui/helpers/variantContext'

/**
 * Navigation action that supports A/B test variants
 * Uses the variant from React Context (managed by Confidence SDK)
 */
export default async function navigateToNextOnboardingPageAction({
  request,
}: {
  request: Request
}) {
  // Get variant from context (stored globally during app initialization)
  const variant = getABTestVariantFromContext()

  return navigateToNextOnboardingPage({
    request,
    routeConfig: glowMinderABTestRouteConfig,
    variant,
    redirectOnComplete: '/sign-up/company',
  })
}
